import { render, staticRenderFns } from "./DetalleDelDia.vue?vue&type=template&id=6fb05cd2&scoped=true"
import script from "./DetalleDelDia.vue?vue&type=script&lang=js"
export * from "./DetalleDelDia.vue?vue&type=script&lang=js"
import style0 from "./DetalleDelDia.vue?vue&type=style&index=0&id=6fb05cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb05cd2",
  null
  
)

export default component.exports